// #/services/registry/openApi/utils/serviceDetailsFromService.ts

import { OpenApiSchemaJson } from '#/types/registry';
import domainNameFromUrl from '#/utils/domainNameFromUrl';

function logoUrlFromUrlRoot(urlRoot?: string) {
  if (urlRoot == null) {
    return;
  }
  const domainName = domainNameFromUrl(urlRoot);
  return `https://logo.clearbit.com/${domainName}?size=256`;
}

export function serviceDetailsFromService(service: OpenApiSchemaJson) {
  const serviceUrlRoot = service?.servers?.[0]?.url;
  const serviceLogoUrl = logoUrlFromUrlRoot(serviceUrlRoot);
  return {
    // TODO
    name: service?.info?.title,
    description: service?.info?.description,
    serviceUrlRoot,
    serviceLogoUrl,
    ...service,
  };
}

export default serviceDetailsFromService;
